import React from 'react'

import { TraceHierarchy, TraceHierarchyNode } from '../domain/Trace'
import Link from '../helper/link'
import { TraceItem } from '../trace/related-traces'
import Profile from './profile'

interface Props {
    traces: TraceHierarchy
    currentTraceId: string
}

const indentPerLevel = 40

const flattenTraceHierarchy = (traceHierarchy: TraceHierarchy): TraceItem[] => {
    const traceItems: TraceItem[] = []

    for (const node of traceHierarchy.nodes) {
        traceItems.push(...flattenTraceHierarchyNode(node, 0))
    }
    return traceItems
}

const flattenTraceHierarchyNode = (node: TraceHierarchyNode, depth: number = 0): TraceItem[] => {
    const traceItems: TraceItem[] = []

    traceItems.push({ trace: node.data, depth })

    for (const child of node.children) {
        traceItems.push(...flattenTraceHierarchyNode(child, depth + 1))
    }

    return traceItems
}

class HierarchicalTraceTable extends React.Component<Props> {
    public render() {
        const traces = flattenTraceHierarchy(this.props.traces)
        return (
            <React.Fragment>
                {traces ? (
                    traces.map((traceItem, index) => {
                        return (
                            <div style={{ paddingLeft: traceItem.depth * indentPerLevel + 'px' }} key={index}>
                                <table
                                    className={`table table-condensed hierarchical-profile-list profile-list ${
                                        traceItem.trace.id === this.props.currentTraceId ? 'selected' : ''
                                    }`}
                                >
                                    <Profile
                                        rowType={index % 2 ? 'even' : 'odd'}
                                        profile={traceItem.trace}
                                        route={'XhprofProfilerBundle.Profile.quick'}
                                    />
                                </table>
                            </div>
                        )
                    })
                ) : (
                    <table>
                        <tbody>
                            <tr>
                                <td colSpan={8} className="text-center">
                                    <p>No traces found for the current time-span and selected criteria.</p>
                                    <p>
                                        <Link route="XhprofProfilerBundle.Profile.list" params={{}}>
                                            Clear filters and see a list of all traces
                                        </Link>
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                )}
            </React.Fragment>
        )
    }
}

export default HierarchicalTraceTable
